import { IMilestone, IMilestonesParams, ITableRes } from 'types'
import { baseApi } from './baseApi'

export const milestonesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_milestones: builder.query<ITableRes<IMilestone>, IMilestonesParams>({
      query: (params) => ({
          url: '/milestones/',
          params: params
      }),
      providesTags: ['milestones'],
    }),
    GET_milestoneById: builder.query<IMilestone, string>({
      query: (id) => {
        return {
          url: `/milestones/${id}/`,
        }
      },
      providesTags: ['milestone'],
    }),
    POST_milestone: builder.mutation<IMilestone, IMilestone>({
      query: (body) => ({
        url: `/milestones/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['milestones'],
    }),
    PUT_milestone: builder.mutation<IMilestone, { id: string; body: IMilestone }>({
      query: ({ id, body }) => ({
        url: `/milestones/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['milestones', 'milestone'],
    }),
    DELETE_milestone: builder.mutation<IMilestone, string>({
      query: (id) => ({
        url: `/milestones/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['milestones'],
    }),
  }),
})

export const {
  useGET_milestonesQuery,
  usePOST_milestoneMutation,
  useGET_milestoneByIdQuery,
  usePUT_milestoneMutation,
  useDELETE_milestoneMutation,
} = milestonesAPI
